import { IconChevronRight } from '@tabler/icons-react';

import { Box, Divider, Link, Typography } from '@mui/material';

import { ContractVacationsAccrualPeriodsEntry } from '@octopus/api';
import { formatDateBR } from '@octopus/formatters';

import { DrawerCard } from './Card';

export const Vacations = (props: {
  vacations: ContractVacationsAccrualPeriodsEntry;
}) => {
  const { accrualPeriods } = props.vacations;
  const firstAccrualPeriod = accrualPeriods[0];
  return (
    <DrawerCard>
      <Typography variant="h4">Férias</Typography>
      <Divider />
      <Box pl={1.25} display="flex" flexDirection="column" gap={0.25}>
        <Box display="flex">
          <Typography variant="h4" py={0.5}>
            {firstAccrualPeriod.daysAvailable} dias
          </Typography>
        </Box>
        <Box display="flex" gap={0.5}>
          <Typography variant="subtitle2" color="text.secondary">
            Aquisitivo:
          </Typography>
          <Typography variant="subtitle2" color="text.primary">
            {formatDateBR(firstAccrualPeriod.startDate)} a{' '}
            {formatDateBR(firstAccrualPeriod.endDate)}
          </Typography>
        </Box>
        <Box display="flex" gap={0.5}>
          <Typography variant="subtitle2" color="text.secondary">
            Concessivo:
          </Typography>
          <Typography variant="subtitle2" color="text.primary">
            {formatDateBR(firstAccrualPeriod.concessionPeriod.startDate)} a{' '}
            {formatDateBR(firstAccrualPeriod.concessionPeriod.endDate)}
          </Typography>
        </Box>
        <Box display="flex" gap={0.5}>
          <Typography variant="subtitle2" color="text.secondary">
            Férias agendadas:
          </Typography>
          <Typography variant="subtitle2" color="text.primary">
            {firstAccrualPeriod.daysScheduled > 0 ? 'Sim' : 'Não'}
          </Typography>
        </Box>
        <Box display="flex" mt={2}>
          <Link
            href="/vacations/admin"
            fontSize="12px"
            display="flex"
            alignItems="center"
            gap={0.5}
            sx={{ textDecoration: 'none' }}
          >
            Ver detalhes em férias
            <IconChevronRight size={16} />
          </Link>
        </Box>
      </Box>
    </DrawerCard>
  );
};
